import { Box, Divider, Paper } from '@mui/material';
import { FC, Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getUserStatisticRequest } from 'redux/reducers/errorCorrections/reducer';
import {
	getUserStatistic,
	getUserStatisticLoader,
} from 'redux/reducers/errorCorrections/selectors';
import { getUsersListRequest } from 'redux/reducers/user/reducer';
import { getUsersList } from 'redux/reducers/user/selectors';
import { UserAvatar } from 'ui/UserAvatar';

const usersStatistic1 = [
	{
		responsibleUser: {
			id: '82be8a46-dcea-4850-97fa-e23dede92ca0',
			email: 'rostislav@easproject.com',
			fullName: 'Rostislav Shakhtakhtinskiy',
		},
		errorsCount: 15,
		status: 'critical',
	},
	{
		responsibleUser: {
			id: '554d7ff8-6099-4e31-9562-6405440fb479',
			email: 'peter@easproject.com',
			fullName: 'Peter Shepelev',
		},
		errorsCount: 45,
		status: 'minor',
	},
	{
		responsibleUser: {
			id: '3f7e137d-9657-42c6-b2f7-d6c53e2a6e57',
			email: 'mikhail@easproject.com',
			fullName: 'Mikhail Muromskii',
		},
		errorsCount: 3,
		status: 'minor',
	},
	{
		responsibleUser: {
			id: '9e94e29b-7b22-4ea7-9ddd-22ac30c91c81',
			email: 'aleksandra@easproject.com',
			fullName: 'Aleksandra Muromskaia',
		},
		errorsCount: 32,
		status: 'normal',
	},
];

export const UserStatistic: FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const usersStatistic = useSelector(getUserStatistic);
	const userStatisticLoader = useSelector(getUserStatisticLoader);

	useEffect(() => {
		dispatch(getUserStatisticRequest());
	}, [dispatch]);

	return (
		<Paper
			sx={{
				margin: '0px 10px 0px 10px',
				maxWidth: 'calc(100vw - 20px)',
				overflowX: 'auto',
			}}
		>
			<Box sx={{ width: 'auto', minWidth: '1200px', p: '5px' }}>
				<Box sx={{ display: 'flex', gap: 1 }}>
					{usersStatistic?.map((user, index) => (
						<Fragment key={user.user.id}>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									cursor: 'pointer',
									gap: 1,
									// p: '10px 10px 10px 10px',
									borderRadius: '12px',
									// border: '1px solid #e0e0e0',
									// 	backgroundColor:
									// 		user.status === 'error'
									// 			? '#FFCDD2'
									// 			: user.status === 'warning'
									// 			? '#FFF9C4'
									// 			: '#C8E6C9',
								}}
								onClick={() =>
									navigate(
										`/error-correction?responsibleUser=${String(user.user.id)}&status=Not Fixed`,
									)
								}
							>
								<Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
									<UserAvatar user={user.user} onClick={() => null} size="xs" />
									<Box
										sx={{
											color:
												user.status === 'critical'
													? 'error.main'
													: user.status === 'minor'
														? 'warning.main'
														: 'success.main',
											fontWeight: 'bold',
											fontSize: '1.1rem',
										}}
									>
										{user.issuesCount}
									</Box>
								</Box>
							</Box>
							<Divider orientation="vertical" flexItem sx={{ borderColor: 'primary.light' }} />
						</Fragment>
					))}
				</Box>
			</Box>
		</Paper>
	);
};
